export function getAssets(lang) {
  // H5P editor doesn't have translations for all languages
  // Fall back to English for unsupported languages
  const supportedH5PLanguages = ['en', 'de', 'fr', 'es', 'it', 'pl', 'ro', 'cz', 'nl', 'tr', 'uk', 'sk', 'zz'];
  const h5pLang = supportedH5PLanguages.includes(lang) ? lang : 'en';

  return {
    css: [
      'core/dist/h5p.css',
      'core/dist/h5p-confirmation-dialog.css',
      'core/dist/h5p-custom-dialog.css',
      'core/dist/h5p-core-button.css'
    ],
    editorCss: [
      'editor/libs/darkroom.css',
      'editor/styles/css/h5p-hub-client.css',
      'editor/styles/css/fonts.css',
      'editor/styles/css/application.css',
      'editor/styles/css/libs/zebra_datepicker.min.css',
    ],
    js: [
      'core/dist/core-integration-bundle.js',
      'editor/dist/bundle.js',
    ],
    currentTranslation: [
      `editor/language/${h5pLang}.js`,
    ],
    allTranslations: [
      `editor/language/en.js`,
      `editor/language/de.js`,
      `editor/language/fr.js`,
      `editor/language/es.js`,
      `editor/language/it.js`,
      `editor/language/pl.js`,
      `editor/language/ro.js`,
      `editor/language/cz.js`,
      `editor/language/nl.js`,
      `editor/language/tr.js`,
      `editor/language/uk.js`,
      `editor/language/sk.js`,
      `editor/language/zz.js`,
    ],
  };

}